import { NUMBER } from "../../constants/app-constants";
const nonFeasibleLocationTypes = ["approximate"];
const publicPlaces = ["railway station", "airport", "bus"];

const isSubLocalityApplicable = (addressComponents) => {
    const count = addressComponents.reduce((acc, location) => {
        return location.types && location.types.includes("sublocality") ? acc + 1 : acc;
    }, 0);

    return count >= NUMBER.TWO ? true : false;
};

export const isLocationFeasibleForInspection = (address) => {
    const { geometry, address_components: addressComponents = [] } = address || {};
    const { location_type: locationType } = geometry || {};
    if (nonFeasibleLocationTypes.includes((locationType || "").toLowerCase())) {
        return isSubLocalityApplicable(addressComponents);
    }
    return true;
};

const isPublicPlace = location => publicPlaces.some(place => location.description.toLowerCase().includes((place || "").toLowerCase()));
// location.types.some(type => publicPlaces.includes(type.toLowerCase()));

export const getPublicLocations = (list) => list.filter((location) => isPublicPlace(location));

export const depriotisePublicLocations = (text, list) => {
    const isPublicPlaceInText = publicPlaces.some(place => {
        return place.toLowerCase().includes(text.toLowerCase());
    });

    if (isPublicPlaceInText) return list;

    const { filteredLocations, nonFilteredLocations } = list.reduce(
        (result, location) => {
            if (isPublicPlace(location)) {
                result.filteredLocations.push(location);
            } else {
                result.nonFilteredLocations.push(location);
            }

            return result;
        },
        { filteredLocations: [], nonFilteredLocations: [] }
    );

    return [...nonFilteredLocations, ...filteredLocations];
};
